var _image;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftburst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 76,
    viewBox: "0 0 52 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 52,
    height: 76,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAABMCAYAAAAiCZRHAAAC6UlEQVRoge2bsXabMBSGf9MMHfMIyRvYe89psrVbF7rm9A3qidHxyETewNkZ7LFbs3TGb5CMHd0XID1KroAgcATSBeGj75wMkezAn19cXaGrGRgJ0ugWwA2AH3kYP3BeS8ImKEijCwAZgHNqugOwzsP4oHzY5nWVFntsKmIEPwE8Bmn0jVMQi0NBGombT5SOkh0NQ+tuWRfUMNTaOJCoXUt/v+srLeYkGmJAn9kGabSlf4J7guj56PqMiM9nNEzN70FpMeOJfroi3EqCNPpt6hZXUBDzz0rp0ONA4V2E+c5wzkNzCt1zpVMPMRGLoNHJcdZMAeZugdy6VVpbYBeE0i0R/a6UTj32FOL3TgiSUCRbaYb1Jt51a1BBKCfejaFby7Zkd3BBEgtuNSa7owmCHbee6kuTUQVJKMOoZ+ddKNxyQhBeRZ2TqL7Lixe3nBEkMXTrwLnA6wUtJy4B3Pf4/to5h6oEaXRFbukkrA95GF8751AVil4LeuiP8bJYhCtRTod33CoyiMkIQhkJV/TCRbLPw3ghf5mUIEltabLQSVonAQ1Dj8fj8XicYRak0fOJ2HEtklmns+0+eEGu4wW5jhfkOme0sXQKsBZ0eDwej8dz0oiCjqY3p2dTE117r31Dm2Nlv/INh6Eym6xSP3RBbQWT2H2goZUcKYQqdiCcHnIt+0FNbGinz90hR65kGmIEc1kR6eK2vq4rdcTyYfFBaR4RqlHYAvjS4y4+AvjnSmmMaRVJUTI9+jNErjwaiBEFGpey/nvM8jIrtT31urlRHKKIZOLKHc09yvuQoUs0rdfHKddQWpggVzIDMes2V6oMUeZso8ZUqyIY3IKGrtkG41EB06r6Tq5U4Tg/NNq5BzBl25+VFj16nXWowyFoSdFMF2NXqlhPTp/TP39n3z/NNKOacOVrHsa/lJ6ecB63yY4EBZbzd2CeWJdKyyu7ajJpG+55KKks1NhceXNNzj9O6YqIWm9SfDYA/Add/AXuxNFrqAAAAABJRU5ErkJggg=="
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftburst);
export default __webpack_public_path__ + "static/media/leftburst.f8591825.svg";
export { ForwardRef as ReactComponent };